import React from 'react'

const DocumentInterface = () => {
    return (
        <div>
            <div className='w-full h-full skeleton'>
                <img className='w-full h-full' src='/images/PowerTheWebDocumentPageBanner.png' srcSet='/images/PowerTheWebDocumentPageBanner.png' alt='PowerTheWeb Document Page Banner' />
            </div>
        </div>
    )
}

export default DocumentInterface